import Vue from 'vue';

export default {
  addComponentWithCancelableRequests(state, name) {
    Vue.set(state.requestCancellers, name, {});
  },
  initCancelableRequests(state, names) {
    names.requests.forEach((name) => {
      Vue.set(state.requestCancellers[names.component], name, null);
    });
  },
  // payload = { component, request: { name, canceller } }
  setCanceller(state, payload) {
    state.requestCancellers[payload.component][payload.request.name] =
      payload.request.canceller;
  },
  removeCanceller(state, names) {
    try {
      state.requestCancellers[names.component][names.request] = null;
    } catch {}
  },
  removeComponentWithCancelableRequests(state, name) {
    Object.values(state.requestCancellers[name]).forEach((canceller) => {
      if (canceller) {
        canceller();
      }
    });
    Vue.delete(state.requestCancellers, name);
  },
  setScroll(state, scrolled) {
    state.scrolled = scrolled;
  },
  setActiveGroup(state, storeActiveGroup) {
    localStorage.RobohomeAdminActiveGroup = storeActiveGroup;
    state.storeActiveGroup = storeActiveGroup;
  },
  setHome(state, home) {
    if (home) {
      localStorage.RobohomeAdminActiveHome = home.uid;
    } else {
      localStorage.RobohomeAdminActiveHome = null;
    }
    state.home = home;
  },
  setEditMode(state, editMode) {
    state.editMode = editMode;
  },
};
